import { HelpMenu as HelpMenuV1 } from 'app/menu/components/TopBarV1/Help'

export const HelpMenu = HelpMenuV1
export default HelpMenu
